import type {PropertyNamespace} from '@github-ui/custom-properties-types'
import {Filter, type FilterProps} from '@github-ui/filter'
import type {SuppliedFilterProvider} from '@github-ui/filter-core'

import {getCustomPropertiesProvider, type PropertyDefinition} from './providers/custom-properties'
import {getAllDateProviders} from './providers/date'
import {LanguageStaticFilterProvider} from './providers/languages'
import {getAllNumberProviders} from './providers/number'
import {getPropertyProviders} from './providers/properties'
import {getAllStaticProviders, type ReposFilterAdditionalOptions} from './providers/static'

export type {PropertyDefinition}

export interface ReposFilterProps extends Omit<FilterProps, 'providers' | 'sx'> {
  namespaces?: PropertyNamespace[]
  definitions?: PropertyDefinition[]
  orgs?: string[]
  options?: ReposFilterAdditionalOptions
}

export function ReposFilter({namespaces, definitions, orgs, options, ...props}: ReposFilterProps) {
  const actualProviders: SuppliedFilterProvider[] = getDefaultReposProviders(definitions, orgs, options, namespaces)

  return <Filter {...props} providers={actualProviders} />
}

export function getDefaultReposProviders(
  definitions?: PropertyDefinition[],
  orgs?: string[],
  options?: ReposFilterAdditionalOptions,
  namespaces?: PropertyNamespace[],
): SuppliedFilterProvider[] {
  const providers: SuppliedFilterProvider[] = [
    ...getAllStaticProviders(orgs, options),
    ...getAllNumberProviders(),
    ...getAllDateProviders(),
  ]

  if (namespaces && namespaces.length > 0) {
    providers.push(...getPropertyProviders(namespaces))
  } else if (definitions && definitions.length > 0) {
    providers.push(getCustomPropertiesProvider(definitions))
  }

  return [...providers, new LanguageStaticFilterProvider()]
}
